// 获取容器节点
export const getEl = (selector: any) => {
    if (typeof selector === 'string') {
        return document.querySelector(selector)
    }

    if (typeof selector === 'function') {
        return selector()
    }

    return selector
}
